import { FormControl, FormGroup } from '@angular/forms';

export class RxComposite {
  public dialog;
  private _payload: any;
  public get payload(): any {
    return this._payload;
  }
  public set payload(value: any) {
    this._payload = value;
  }
  public file = {
    jpg: 'image/jpeg',
    png: 'image/png',
  };
  public isValid() {
    return true;
  }
  public validate() {}
}
